import React, { FC } from 'react';
import classNames from 'classnames/bind';

import { IButton } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

/**
 Компонент для оборачивания составных кликабельных компонентов,
 которые нельзя прокинуть в компонент Button из carnica
 */
export const Button: FC<IButton> = ({ children, onClick, className }) => {
  return (
    <button className={cn('wrap', className)} onClick={onClick} type="button">
      {children}
    </button>
  );
};
